
import React, { Dispatch } from "react";
import ReactModal from "react-modal";
import { deleteComment } from "../../api";

type typeProps = {
    showDeleteComment: boolean;
    setShowDeleteComment: Dispatch<React.SetStateAction<boolean>>;
    concretComment: any;
    setConcretComment: Dispatch<React.SetStateAction<any>>;
    getAllClientComments: () => Promise<void>;
}

function DeleteComment({ showDeleteComment, setShowDeleteComment, setConcretComment, getAllClientComments, concretComment }: typeProps ) {

    const closeWindow = () => {
        setConcretComment({});
        setShowDeleteComment(false);
    }

    const deleteCommentData = async (): Promise<void> => {
        const responseData = await deleteComment(concretComment.id);
        if (responseData.data) {
            await getAllClientComments();
            closeWindow();
        }
    }

    return(
        <ReactModal
            isOpen = { showDeleteComment }
            onRequestClose = { () => closeWindow() }
            style = {{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    zIndex: 300,
                },
                content: {
                    width: "80%",
                    maxWidth: '550px',
                    maxHeight: "200px",
                    height: "55vh",
                    border: 'none',
                    margin: "auto",
                    borderRadius: "10px",
                    background: 'white',
                    WebkitOverflowScrolling: 'touch',
                    outline: 'none',
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: 'column',
                    alignItems: "center",
                    justifyContent: "space-evenly",
                }
            }}
        >
            <div className = 'modal-deleteClient-content'>
                Do You Want to Delete this Comment?
            </div>
            <div className = "delete-comment-btns-box">
                <button
                    className = "cancel-delete-button"
                    onClick = { () => closeWindow() }
                >
                    Cancel
                </button>
                <button
                    className = "delete-comment-button"
                    onClick = { deleteCommentData }
                >
                    Delete
                </button>
            </div>
        </ReactModal>
    )
}

export default DeleteComment;